// Translations
import { useTrans } from "@/i18n"

/**
 * Footer
 */
export function Footer() {
	const t = useTrans()

	return (
		<footer className="flex-1 px-4 pb-6 sm:px-7">
			<div className="flex max-w-7xl">
				<div className="flex flex-wrap gap-8 text-left">
					&copy; {t("common:common.brand.name")} 2025
				</div>
			</div>
		</footer>
	)
}
